function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  letter: "L",
  d: "M4.86076 0.303833H0V21.9747H21.7215V17.6203H4.86076V0.303833Z",
  fill: "#00000A"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  letter: "I",
  d: "M29.62 0.303833H24.7593V21.9747H29.62V0.303833Z",
  fill: "#00000A"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  letter: "Q",
  d: "M61.48 11.143C61.526 8.438 60.561 6.007 58.681 4.108 56.121 1.52 51.94.025 47.235 0 47.159 0 47.57 0 47.499 0 42.643-.02 38.395 1.479 35.794 4.103 33.92 6.002 32.954 8.438 33 11.138 33 15.915 35.992 19.597 40.92 21.274 42.033 21.653 44.157 22.089 45.223 22.17 47.753 22.459 44.823 21.857 44.812 22.17V24.692C44.812 26.643 46.179 28.005 48.134 28.005H57.101V23.968H50.309C49.572 23.968 49.405 23.801 49.405 23.067V22.165C56.862 21.37 61.486 17.166 61.486 11.148L61.48 11.143ZM47.317 17.941H47.195C42.597 17.941 37.493 15.839 37.493 11.138 37.493 6.438 42.597 4.336 47.195 4.336H47.317C51.899 4.336 56.527 6.438 56.527 11.138 56.527 15.839 51.899 17.941 47.317 17.941Z",
  fill: "#00000A"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  letter: "U",
  d: "M82.6329 11.8481C82.6329 15.8988 80.5064 17.9241 76.3038 17.9241H75.6962C71.4937 17.9241 69.3671 15.8988 69.3671 11.8481V.3038H64.5063V12.1519C64.5063 18.481 68.557 22.2279 75.6456 22.2785 75.8481 22.2785 76.2026 22.2785 76.3038 22.2785 83.2912 22.1773 87.4937 18.3798 87.4937 12.1519V.3038H82.6329V11.8481Z",
  fill: "#00000A"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  letter: "I2",
  d: "M95.3925 0.303833H90.5317V21.9747H95.3925V0.303833Z",
  fill: "#00000A"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  letter: "D",
  d: "M111.848 0.303833H98.4302V21.9747H111.848C119.342 21.9747 124.202 17.7216 124.202 11.1393C124.202 4.557 119.392 0.303833 111.848 0.303833ZM111.19 17.6203H103.291V4.65826H111.139C114.835 4.65826 119.24 5.77219 119.24 11.1393C119.24 16.5064 114.886 17.6203 111.19 17.6203Z",
  fill: "#00000A"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  letter: "I3",
  d: "M132.101 0.303833H127.24V21.9747H132.101V0.303833Z",
  fill: "#00000A"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  letter: "T",
  d: "M135.139 4.65826H145.164V21.9747H150.025V4.65826H160.051V0.303833H135.139V4.65826Z",
  fill: "#00000A"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  letter: "Y",
  d: "M180.253.3038 173.367 8.2532 166.532.3038H160.051L170.886 12.6583V21.9747H175.747V12.6583L186.532.3038H180.253Z",
  fill: "#00000A"
});
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 29,
    viewBox: "0 0 212 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, /*#__PURE__*/React.createElement("rect", {
    className: "logo-triggerL",
    x: 0.002,
    y: 0.053,
    width: 21.891,
    height: 22.056,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo-triggerQ",
    x: 32.398,
    y: -0.363,
    width: 29.2,
    height: 22.763,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo-triggerD",
    x: 98.058,
    y: 0.176,
    width: 26.179,
    height: 22.079,
    style: {
      fill: "transparent"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a46f250d.svg";
export { ForwardRef as ReactComponent };